import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { captureError } from "../../lib/fatal";

/**
 * Route-level error boundary: never shows the raw error, offers a retry and a way home.
 * The error still has to survive somewhere, or a support conversation is guesswork, so it goes to the
 * diagnostics page instead of only to a console nobody will open.
 */
export function ErrorScreen({ error, reset }: { error: unknown; reset: () => void }) {
  const router = useRouter();
  useEffect(() => {
    captureError("render", error, "route");
  }, [error]);
  return (
    <Box sx={{ minHeight: "100dvh", display: "grid", placeItems: "center", p: 3, textAlign: "center" }}>
      <Stack spacing={2} alignItems="center" sx={{ maxWidth: 420 }}>
        <Typography variant="h5">Something went wrong</Typography>
        <Typography color="text.secondary">
          The page hit an error it could not recover from. Reload to pick up where you left off.
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            onClick={() => {
              reset();
              void router.invalidate();
            }}
          >
            Try again
          </Button>
          <Button variant="outlined" onClick={() => window.location.assign("/")}>
            Go home
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
